export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7,
}



// WEBPACK FOOTER //
// ./components/vc-calendar/src/date/DateConstants.js